import type { PushStatus } from 'pwa/helpers/pushNotifications';

export type PushNoticeKey =
  | 'failed'
  | 'notAllowed'
  | 'blocked'
  | 'needsInstall'
  | 'unsupported';

const STATUS_NOTICES: Partial<Record<PushStatus, PushNoticeKey>> = {
  off: 'notAllowed',
  blocked: 'blocked',
  'needs-install': 'needsInstall',
  unsupported: 'unsupported',
};

export default function getPushNoticeKey(
  wantsPush: boolean,
  status: PushStatus | null,
  hasFailed: boolean
): PushNoticeKey | null {
  if (!wantsPush) return null;
  if (hasFailed) return 'failed';
  if (!status) return null;
  return STATUS_NOTICES[status] ?? null;
}
